import bidmanagerGetters from './getters/index';
import bidmanagerMutations from './mutations/index';
import bidmanagerActions from './actions/index';
import {STORE_TYPES, BIDDABLE_TYPES} from 'store/modules/bidmanager/utils/common';
import translation from 'translation';
import webanalyticsStore from 'store/modules/webanalytics';

export const {
  SET_CURRENT_BIDMANAGER_GROUP,
  SET_CURRENT_BIDMANAGER_GROUP_ID,
  SET_PROGRESS_METRICS_LOADING,
  SET_VALIDATION_RULES_ERRORS,
  SET_PLACEMENTS,
  SET_GROUPS,
  SET_GROUPS_TOTAL,
  SET_CURRENT_PAGE,
  SET_PROGRESS_DATA,
  SET_SORTING,
  SET_PER_PAGE,

  FETCH_PLACEMENTS,
  FETCH_GROUPS,
  FETCH_PROGRESS_METRICS_COLUMN,
  DELETE_GROUP_REQUEST,
  TOGGLE_ENABLING,
  FETCH_PROJECT_ANALYTICS,

  FLUSH_STORE,
  FETCH_GROUP,
  SAVE_GROUP,
  FETCH_PARAMS,
  CHANGE_CHANNEL,
  INIT_GROUP,
  COPY_FROM_GROUP,
  ADD_RULE,
  ADD_DEFAULT_RULE,
  SET_RULE,
  MOVE_RULES,
  RESET_RULES,
  RESET_GROUP_AFTER_PLACEMENT_CHANGE,
  UPDATE_GROUP,
  UPDATE_GROUP_OPTIONS,
  DELETE_RULE,
  COPY_RULE,
  SET_LABELS,
  SET_PLACEMENT_IDS,
  SET_ACTION,
  ADD_CONDITION,
  SET_CONDITION,
  SET_FALLBACK_ACTION,
  TOGGLE_FALLBACK_ACTION_STATE,
  REMOVE_CONDITION,
  SET_VALUE,
  SET_ENABLE_ON,
  SET_LOADING_CHANNEL_STATE,
  SET_ERRORS,
  TOGGLE_RULE,
  SET_BIDDABLE_TYPE,
  SET_STRATEGY_TYPE,
  SET_AUTOSTRATEGY_ID,
  SWITCH_AUTOSTRATEGY_VARIANT,
  RESET_AUTOSTRATEGY_ARGUMENTS,
  SET_AUTOSTRATEGY_ARGUMENT,
  SET_STRATEGIES_LIST,
  FETCH_STRATEGIES_LIST,
  RESET_AUTOSTRATEGY,
  CONVERT_AUTOSTRATEGY_TO_MANUAL_STRETEGY,
  RESET_STRATEGY
} = STORE_TYPES;

export const fallbackRuleUid = 'fallback-rule';
export const DEFAULT_RUN_TYPE = 'SCHEDULE';

export const getRunEverydayDays = () => Array.from(Array(7)).map((i, x) => x);

// export const getRunOnceTime = () => Array.from(Array(24)).map((i, x) => x);
export function getRunOnceTime () {
  return Array.from(Array(24)).map((i, x) => x);
}


export const getDefaultFallBackRule = () => ({
  action: {},
  conditions: [],
  enabled: false,
  uid: fallbackRuleUid
});

export const getDefaultState = () => ({
  group: {
    name: '',
    channel_id: null,
    placement_ids: [],
    labels: [],
    manageOn: '',
    handleInactiveKeywords: false,
    is_logging_enabled: true,
    run_type: DEFAULT_RUN_TYPE,
    progress_metrics: {metrics: []},
    time_of_day: getRunOnceTime(), // run once a day
    day_of_week: getRunEverydayDays(), // run every day
    enabled: true,
    options: {
      fallbackRule: getDefaultFallBackRule(),
      rules: [],
      biddable: BIDDABLE_TYPES.KEYWORD.id,
      process_inactive_biddables: false
    },
    autostrategy_id: null,
    autostrategy_arguments_values: {}
  },
  errors: {},
  validationRulesErrors: {},
  isNew: true,
  isSelectableBiddableForPlacement: false,

  // computed in existing groups
  enableOn: 'placements',
  enableOnChoices: [
    {id: 'labels', name: () => translation.trc('prepositional', 'labels')},
    {id: 'placements', name: () => translation.trc('prepositional', 'placements')}
  ],

  // make bids for what: keywords, placements, etc.
  biddableTypesChoices: [],
  types: [],
  operators: [],
  dateframes: [],
  fields: [],
  actions: [],
  positions: [],

  placementChoices: [],
  labelChoices: [],
  isLoggingAvailable: false,
  profiles: [],
  goals: [],
  channelLoading: false,
  biddableForDefaultName: '',
  serverGroupState: null,
  progressMetrics: [],
  strategyType: null,

  autostrategiesList: []
});

// do not mutate this value! it must be used only for comparisons
export const initDefaultState = getDefaultState();

export function getBiddableActions (actions, biddable) {
  function isActionForBiddable (action) {
    return action.biddable === biddable || _.isUndefined(action.biddable) && !_.contains(action.exclude, biddable);
  }

  function normalizeAction (action) {
    return {...action, id: action.biddable_id || action.id};
  }

  return actions.filter(isActionForBiddable).map(normalizeAction);
}

const bidmanagerStore = {
  namespaced: true,
  modules: {
    bidmanagerAnalytics: webanalyticsStore
  },
  state () {
    return {
      currentBidmanagerGroup: null,

      isProgressMetricsLoading: true,
      currentPage: 1,
      perPage: 10,
      placements: [],
      groups: [],
      groupsTotal: null,
      progressData: [],
      progressDataMap: {},
      sorting: [{direction: 'desc', name: 'id'}],
      profiles: [],
      goals: [],
      ...getDefaultState()
    };
  },
  getters: {
    ...bidmanagerGetters
  },
  mutations: {
    ...bidmanagerMutations
  },
  actions: {
    ...bidmanagerActions
  }
};

export default bidmanagerStore;
